import { cn } from "@/lib/utils";
import { Input } from "../ui/input";
import { forwardRef } from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const InputPrimary = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    // Default to the shared large radius so all inputs in headers match buttons
    return (
      <Input
        ref={ref}
        className={cn("!bg-background rounded-lg", className)}
        {...props}
      />
    );
  },
);

InputPrimary.displayName = "InputPrimary";
